import React from 'react';
import ListTemplate from '../../../Reusable_Components/ListTemplate';
import { API_ROUTES, API_DOMAIN } from '../../../Reusable_Components/Config/apiConfig';
import { fmtDateTime } from '../../../../utils/fmt';

const AuditLogList = () => {
  const columns = [
    { label: 'Action', value: 'action' },
    { label: 'Model', value: 'model_name' },
    { label: 'Record ID', value: 'object_id' },
    { label: 'User', value: 'user_name' },
    { label: 'Timestamp', value: (item) => fmtDateTime(item.timestamp) },
  ];

  return (
    <ListTemplate
      columns={columns}
      fetchUrl={API_DOMAIN + API_ROUTES['auditLog']}
    />
  );
};

export default AuditLogList;